<template>
  <div class="d-flex">
    <GmapMap
      :center="center"
      :zoom="7"
      style="width:100%;  height: 500px;"
      v-if="markers.length > 0"
    >
      <GmapMarker
        v-for="marker in markers"
        :key="marker.key"
        :position="marker.position"
        :clickable="true"
        :draggable="false"
        @click="markerClicked(marker)"
      >
        <InfoWindow
          :opened="marker.infoWindow.show"
          @closeclick="marker.infoWindow.show = false"
          :options="infoOptions"
        >
          <div>
            <h3>{{ marker.key }}</h3>
          </div>
        </InfoWindow>
      </GmapMarker>
    </GmapMap>
    <br />
  </div>
</template>

<script>
import { InfoWindow } from "vue2-google-maps";

export default {
  name: "GoogleMap",
  components: { InfoWindow },
  data: () => ({
    markers: [],
    center: { lat: 30.5609, lng: -115.94 }
  }),
  created() {
    // this.geolocate();
    console.warn(this.markers.length);
    this.setMarkers();
  },
  props: {
    locations: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    setMarkers: function() {
      this.markers = this.locations.map(location => {
        return {
          position: {
            lat: location[1],
            lng: location[2]
          },
          key: location[0],
          defaultAnimation: 2,
          infoWindow: {
            show: false,
            content: location[0]
          }
        };
      });
    },
    markerClicked: function(marker) {
      console.log(marker);
      marker.infoWindow.show = true;
    }
  }
};
</script>
